import { Routes } from '@angular/router';

import { AppShellComponent } from './components/app-shell/app-shell.component';
import { ApiKeyComponent } from './features/api-key/api-key.component';
import { ApiKeyGuideComponent } from './features/api-key-guide/api-key-guide.component';
import { BrandingComponent } from './features/branding/branding.component';
import { BrandEmailTemplateDetailComponent } from './features/brand-email-template-detail/brand-email-template-detail.component';
import { CreateBrandComponent } from './features/create-brand/create-brand.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { DocumentCreateComponent } from './features/document-create/document-create.component';
import { DocumentReadonlyViewComponent } from './features/document-readonly-view/document-readonly-view.component';
import { DocumentViewComponent } from './features/document-view/document-view.component';
import { DocumentsListComponent } from './features/documents-list/documents-list.component';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './features/login/login.component';
import { MyProfileComponent } from './features/my-profile/my-profile.component';
import { EditBrandComponent } from './features/edit-brand/edit-brand.component';
import { SenderIdentitiesComponent } from './features/sender-identities/sender-identities.component';
import { SenderIdentityApproveComponent } from './features/sender-identity-approve/sender-identity-approve.component';
import { SignRequestComponent } from './features/sign-request/sign-request.component';
import { SignupComponent } from './features/signup/signup.component';
import { TemplateCreateComponent } from './features/template-create/template-create.component';
import { TemplatesListComponent } from './features/templates-list/templates-list.component';
import { WebhooksComponent } from './features/webhooks/webhooks.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
  },
  {
    path: 'sign/:token',
    component: SignRequestComponent,
  },
  {
    path: 'developers/api/reference',
    component: ApiKeyGuideComponent,
  },
  {
    path: 'developers/api/get-api-key',
    pathMatch: 'full',
    redirectTo: 'developers/api/reference',
  },
  {
    path: 'developers/api/configure-fields/:token',
    component: DocumentCreateComponent,
  },
  {
    path: 'developers/api/configure-template-fields/:token',
    component: TemplateCreateComponent,
  },
  {
    path: 'review/:token',
    component: DocumentReadonlyViewComponent,
  },
  {
    path: 'sender-identity/approve/:token',
    component: SenderIdentityApproveComponent,
  },
  {
    path: 'templates/new',
    component: TemplateCreateComponent,
    canActivate: [authGuard],
  },
  {
    path: 'templates/:id/edit',
    component: TemplateCreateComponent,
    canActivate: [authGuard],
  },
  {
    path: 'documents/new',
    component: DocumentCreateComponent,
    canActivate: [authGuard],
  },
  {
    path: 'documents/:id/edit',
    component: DocumentCreateComponent,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'templates',
        component: TemplatesListComponent,
      },
      {
        path: 'documents',
        component: DocumentsListComponent,
        data: { listMode: 'active' },
      },
      {
        path: 'documents/drafts',
        component: DocumentsListComponent,
        data: { listMode: 'active', fixedStatus: 'draft' },
      },
      {
        path: 'documents/trash',
        component: DocumentsListComponent,
        data: { listMode: 'trash' },
      },
      {
        path: 'documents/:id/overview',
        component: DocumentViewComponent,
      },
      {
        path: 'documents/:id/view',
        component: DocumentReadonlyViewComponent,
      },
      {
        path: 'api-management/api-key',
        component: ApiKeyComponent,
      },
      {
        path: 'api-management/webhooks',
        component: WebhooksComponent,
      },
      {
        path: 'api-management/sender-identities',
        component: SenderIdentitiesComponent,
      },
      {
        path: 'settings/profile',
        component: MyProfileComponent,
      },
      {
        path: 'settings/branding/new',
        component: CreateBrandComponent,
      },
      {
        path: 'settings/branding/:brandId/edit/email-content/:templateType',
        component: BrandEmailTemplateDetailComponent,
      },
      {
        path: 'settings/branding/:brandId/edit',
        component: EditBrandComponent,
      },
      {
        path: 'settings/branding',
        component: BrandingComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
